import { Suspense } from 'react';
import { Loader } from 'lucide-react';

interface LazyComponentProps {
  children: React.ReactNode;
}

export const LazyComponent = ({ children }: LazyComponentProps) => (
  <Suspense
    fallback={
      <div className="flex h-screen items-center justify-center">
        <Loader className="animate-spin-slow" />
      </div>
    }
  >
    {children}
  </Suspense>
);
